<template>
  <a-visibility show :on="[$breakpoint.mobile]">
    <div class="a-join-telegram__container">
      <telegram-button
        v-observe-visibility="onObserveStaticButton"
        :channel-type="channelType"
      />

      <div
        v-if="semiSticky"
        class="a-join-telegram__fixed-container"
        :style="dynamicStyle"
      >
        <div class="a-join-telegram__button-wrapper">
          <telegram-button :channel-type="channelType" />
        </div>
      </div>
    </div>
  </a-visibility>
</template>

<script>
import _throttle from 'lodash.throttle'

import TelegramButton from './TelegramButton'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

export default {
  name: 'AJoinTelegram',
  mixins: [hydrationHelpers],
  components: { TelegramButton },
  props: {
    channelType: propValidator([PROP_TYPES.STRING], false),
    topOffset: propValidator([PROP_TYPES.NUMBER], false, 3),
    semiSticky: propValidator([PROP_TYPES.BOOLEAN], false, true)
  },
  data() {
    return {
      prevScrollPosition: null,
      currentScrollPosition: null,
      isScrollingTop: false,
      isScrollingAboveButton: true,
      isStaticButtonObserved: false,
      throttledOnScrollFunc: null
    }
  },
  computed: {
    isFixedButtonVisible() {
      return (
        !this.isStaticButtonObserved &&
        this.isScrollingTop &&
        !this.isScrollingAboveButton
      )
    },
    dynamicStyle() {
      const top = this.isFixedButtonVisible
        ? this.$_hydrationHelpers_menuHeight + this.topOffset
        : -50
      return {
        top: `${top}px`
      }
    }
  },
  methods: {
    onObserveStaticButton(isObserved, { boundingClientRect }) {
      if (!this.semiSticky) return

      this.isScrollingAboveButton = boundingClientRect.top > 0
      this.isStaticButtonObserved = isObserved
    },
    onScroll() {
      this.currentScrollPosition = this.$helper.getWindowScrollTop()
      this.isScrollingTop = this.prevScrollPosition > this.currentScrollPosition
      this.prevScrollPosition = this.currentScrollPosition
    },
    initializeStickyButton() {
      this.throttledOnScrollFunc = _throttle(this.onScroll, 200)
      this.prevScrollPosition = this.$helper.getWindowScrollTop()
      window.addEventListener('scroll', this.throttledOnScrollFunc)
    }
  },
  mounted() {
    if (this.semiSticky) {
      this.initializeStickyButton()
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.throttledOnScrollFunc)
  }
}
</script>

<style lang="scss" scoped>
.a-join-telegram {
  &__container {
    position: relative;
    display: flex;
    justify-content: flex-end;
  }

  &__fixed-container {
    position: fixed;
    width: 100%;
    display: flex;
    justify-content: center;
    left: 0;
    z-index: 11;
    transition: top 0.5s ease-in-out;
  }

  &__button-wrapper {
    @extend .a-join-telegram__container;

    width: calc(100% - #{$mobile-body-padding} * 2);
  }
}
</style>
